<template>
	<div>
		<v-dialog v-model="invoice_template_dialog" no-click-animation persistent scrollable content-class="select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width>Select Template</v-subheader>
	        	</v-card-title>

	        	<v-divider></v-divider>

		        <v-card-text full-height nopadding>

			        <v-list nopadding>
			        	<div v-for="(item, index) in items" :key="index">
			        		<v-list-tile @click="updateInvoiceTemplate(item)">
					            <v-list-tile-content>
					              <v-list-tile-title>{{item.name}}</v-list-tile-title>
					            </v-list-tile-content>
					            <v-list-tile-action>
					              <v-icon v-if="item.id == $parent.Form.invoiceTemplate">done</v-icon>
					            </v-list-tile-action>
				        	</v-list-tile>

				        	<v-divider v-if="items.length-1 != index"></v-divider>
			        	</div>
			        	
			        </v-list>

		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		        </v-card-actions>
		    </v-card>


	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['items', 'updateInvoiceTemplate'],
		data(){
			return{
				invoice_template_dialog:false,
			}
		},
		methods:{
			openDialogWeb: function () {
				this.invoice_template_dialog = true;
			},
			closeDialogWeb: function () {
				this.invoice_template_dialog = false;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/print_templates/dialogs/dialog_invoice_template.vue